module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLight.570a244c.ttf";